import React from 'react';
import { Box, Chip, Button } from '@mui/material';

export default function FilterChips({
  filters,
  onClearSearch,
  onClearStatus,
  onClearDateFrom,
  onClearDateTo,
  onClearAll,
}) {
  const { search, statuses, dateFrom, dateTo } = filters;
  const hasAny = search || (statuses && statuses.length > 0) || dateFrom || dateTo;
  if (!hasAny) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1, alignItems: 'center' }}>
      {search && (
        <Chip label={`Search: "${search}"`} size="small" onDelete={onClearSearch} />
      )}
      {statuses && statuses.map((s) => (
        <Chip key={s} label={`Status: ${s}`} size="small" onDelete={() => onClearStatus(s)} />
      ))}
      {dateFrom && (
        <Chip label={`From: ${dateFrom}`} size="small" onDelete={onClearDateFrom} />
      )}
      {dateTo && (
        <Chip label={`To: ${dateTo}`} size="small" onDelete={onClearDateTo} />
      )}
      {onClearAll && (
        <Button size="small" onClick={onClearAll} sx={{ ml: 0.5, textTransform: 'none' }}>
          Clear all
        </Button>
      )}
    </Box>
  );
}
